export const P00058ProgrammeFiltrationAuto = [
  {
    ref: 0,
    label: 'P00058.programme.horlogeEte',
    visible: true,
    value: 'P00058.card.status.eteSmall',
  },
  {
    ref: 1,
    label: 'P00058.programme.horlogeHiver',
    visible: true,
    value: 'P00058.card.status.hiverSmall',
  },
  {
    ref: 2,
    label: 'P00058.programme.prog72H',
    visible: false,
    value: 'P00058.card.status.72h',
  },
  {
    ref: 3,
    label: 'P00058.programme.baignade',
    visible: true,
    value: 'P00058.card.status.baignade',
  },
];

export const P00058ProgrammeFiltrationManuel = [
  {
    ref: 0,
    label: 'P00058.card.status.v1',
    visible: true,
    value: 'P00058.card.status.v1',
  },
  {
    ref: 1,
    label: 'P00058.card.status.v2',
    visible: true,
    value: 'P00058.card.status.v2',
  },
  {
    ref: 2,
    label: 'P00058.card.status.max',
    visible: false,
    value: 'P00058.card.status.max',
  },
];
